import { Flex, Form } from 'antd'
import { FormInstance } from 'antd/lib'

import { AdminConsumableCreateTable } from './AdminConsumableCreateTable'

type Props = {
  form: FormInstance
}

export const AdminConsumableCreateList = ({ form }: Props) => {
  return (
    <Flex vertical gap={16}>
      <Form.List name="inquiryItems">
        {(fields, { add, remove }) => (
          <AdminConsumableCreateTable
            form={form}
            fields={fields}
            add={add}
            remove={remove}
          />
        )}
      </Form.List>
    </Flex>
  )
}
